// extracted by mini-css-extract-plugin
module.exports = {"background":"icOEB","container":"+lIK3","dialogue":"-9m-v"};